import { render } from "./uiLoader.vue?vue&type=template&id=ff7e7416&scoped=true"
import script from "./uiLoader.vue?vue&type=script&lang=js"
export * from "./uiLoader.vue?vue&type=script&lang=js"

import "./uiLoader.vue?vue&type=style&index=0&id=ff7e7416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7e7416"]])

export default __exports__